require.register("app/restaurant/analyse/Form", function(exports, require, module){
  $0
  
});

